export default {"src":"/_next/static/media/detached-farmhouses-icon-selected.7e76216e.svg","height":86,"width":108,"blurWidth":0,"blurHeight":0};